module.exports = __webpack_public_path__ + "img/announce-hanging.e61ed4e6.svg";